import {
  progress,
  progressBar,
  label_progress,
  label_progressBar,
  progressValue,
  progressTotal,
} from './consts';

export default function (editor, opts = {}) {
  const domc = editor.DomComponents;
  const defaultType = domc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;

  domc.addType(progress, {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          'custom-name': label_progress,
          resizable: true,
          components: {
            type: progressBar,
            draggable: false,
            droppable: false,
            copyable: false,
            removable: true,
            attributes: {
              class: progressBar,
              role: 'progressbar',
              'aria-valuenow': 25,
              'aria-valuemin': 0,
              'aria-valuemax': 100,
            },
            style: { width: '25%' },
          },
          script: function () {
            console.log('>>>>>> ProgressBar SCRIPTTTTT');
          },
        },
        init() {
          console.log('>>>>>> ProgressBar init', this);
        },
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') === 'progress') {
            return { type: progress };
          }
        },
      },
    ),
    view: defaultView,
  });
  domc.addType(progressBar, {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          'custom-name': label_progressBar,
          resizable: true,
          tagName: 'div',
          classes: [progressBar],
          traits: [
            ...defaultModel.prototype.defaults.traits,
            {
              type: 'class_select',
              options: [
                { value: '', name: 'Default' },
                { value: 'bg-success', name: 'Success' },
                { value: 'bg-info', name: 'Info' },
                { value: 'bg-warning', name: 'Warning' },
                { value: 'bg-danger', name: 'Danger' },
              ],
              label: 'Background',
            },
            {
              type: 'class_select',
              options: [
                { value: '', name: 'No' },
                { value: 'progress-bar-striped', name: 'Yes' },
              ],
              label: 'Striped',
            },
            {
              type: 'class_select',
              options: [
                { value: '', name: 'No' },
                { value: 'progress-bar-animated', name: 'Yes' },
              ],
              label: 'Animated Stripes',
            },
            {
              type: progressValue,
              name: progressValue,
              label: false,
            },
            {
              type: progressTotal,
              name: progressTotal,
              label: false,
            },
          ],
        },
        init() {
          const attrs = this.getAttributes();
          console.log('>>>>>> ProgressBar init attrs', attrs);
          console.log('>>>>>> ProgressBar init this', this);
        },
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') === 'progress-bar') {
            return { type: progressBar };
          }
        },
      },
    ),

    view: defaultView,
  });
}
